import React from "react";

export const MessageCircleIcon = ({
  strokeWidth = 3,
  size = "24",
  cursor = "pointer",
  color = "currentColor"
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
      <path
        d="M15.9273 9.89821C15.9273 13.6136 12.9154 16.6255 9.19997 16.6255C8.30513 16.6255 7.45109 16.4508 6.67012 16.1336C6.52065 16.0729 6.44591 16.0426 6.3855 16.029C6.3264 16.0158 6.28267 16.0109 6.22211 16.0109C6.1602 16.0109 6.09276 16.0222 5.95789 16.0446L3.29844 16.4879C3.01995 16.5343 2.8807 16.5575 2.78001 16.5143C2.69188 16.4765 2.62165 16.4063 2.58385 16.3182C2.54066 16.2175 2.56387 16.0782 2.61029 15.7997L3.05353 13.1403C3.07601 13.0054 3.08725 12.938 3.08724 12.8761C3.08723 12.8155 3.08239 12.7718 3.06914 12.7127C3.0556 12.6523 3.02525 12.5775 2.96454 12.4281C2.64737 11.6471 2.47266 10.793 2.47266 9.89821C2.47266 6.18282 5.48458 3.1709 9.19997 3.1709C12.9154 3.1709 15.9273 6.18282 15.9273 9.89821Z"
        stroke="black"
        strokeWidth="1.34546"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
